import { Request } from '@/classes/Request.ts'

export interface EnrollmentAcceptTermsResponse {
  success: boolean
  data?: {
    terms_current?: boolean
    current_terms_id?: number | null
  }
  failure_reason?: string
}

/**
 * Record the invitee's acceptance of the current ToS (SOW-46/141). The target
 * user is resolved from the invitation server-side; no id is sent.
 * POST /api/enrollment/invitation/{token}/accept-terms
 */
export const enrollmentAcceptTerms = async (
  token: string
): Promise<EnrollmentAcceptTermsResponse> => {
  const response = await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/accept-terms`
  )
  return response.data
}
